import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import RegisterPage from "./pages/RegisterPage";
import HomePage from "./pages/HomePage";
import MyCoursePage from "./pages/MyCoursePage";
import ErpPage from "./pages/course/ErpPage";
import EcommercePage from "./pages/course/EcommercePage";
import LogisticPage from "./pages/course/LogisticPage";
import BookingPage from "./pages/course/BookingPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/mycourse" element={<MyCoursePage />} />
        <Route path="/ecommerce" element={<EcommercePage />} />
        <Route path="/erp" element={<ErpPage />} />
        <Route path="/logistic" element={<LogisticPage />} />
        <Route path="/booking" element={<BookingPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
